import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';

import {
    BrowserRouter as Router,
} from "react-router-dom";

import 'semantic-ui-css/semantic.min.css';
import './App.css';
import App from './App';

const Page=()=>
<React.StrictMode>
  <Router>
    <App/>
  </Router>
</React.StrictMode>
if (document.getElementById('root')) {
    ReactDOM.render(<Page />, document.getElementById('root'));
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
